module.exports = __webpack_public_path__ + "dingbeauty-build/img/1@2.f1439c62.jpg";